export var NetworksType;
(function (NetworksType) {
    NetworksType["TRX_USDT_S2UZ"] = "TRX_USDT_S2UZ";
    NetworksType["USDT_BSC"] = "USDT_BSC";
    NetworksType["SOL_USDT_EWAY"] = "SOL_USDT_EWAY";
    NetworksType["USDT_ERC20"] = "USDT_ERC20";
    NetworksType["SOL_USDC_PTHX"] = "SOL_USDC_PTHX";
    NetworksType["USDC_ETH"] = "USDC";
})(NetworksType || (NetworksType = {}));
//# sourceMappingURL=networks.js.map